import { render } from "./VF-select.vue?vue&type=template&id=51bb4f7d"
import script from "./VF-select.vue?vue&type=script&lang=js"
export * from "./VF-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__